<template>
  <div id="upload">
  <p id="upload-handle"> Background image </p>
  <div id="upload-content">
    <!-- <form @submit.prevent="onSubmit" enctype="multipart/form-data"> -->
    <form @submit.prevent="uploadImage" enctype="multipart/form-data">

        <label for="file-upload"
          >
          Choose Image
        </label>
        <input 
          id="file-upload"
          type="file"
          ref="background_image"
          @change="onSelect"
        />
  
        <button>Submit</button>
      <div class="message">
        <p> {{selected_string}} </p>
        <p> {{message}} </p>
      </div>

    </form>
    <!-- <form> -->
    <button v-on:click="resetBackground">Reset background</button>
    <!-- </form> -->
  </div>
  </div>

</template>


<script>
import axios from 'axios'
import interactions from "../interactions";
import {location} from "../Location"

export default {
  name: "FileUpload",
  data(){
    return {
      file:"",
      message:"",
      selected_string:"",
      x: null,
      y:null,
      fold: true,
      ratioLock: false
    }
  },

  methods:{
    onSelect(){
      this.file = this.$refs.background_image.files[0];
      this.selected_string = this.file.name;
    },

    async onSubmit(){
      const formData = new FormData()
      formData.append('background_image',this.file)

      const loc = location()
      try{
        await axios.post(`${loc}upload`,formData)
        this.message = 'Uploaded!'
      }
      catch(err){
        console.log(err)
        this.message = "Something went wrong :( " 
      }

      this.$emit('uploaded-new-image') // tell local to refresh
      this.$socket.emit('newImage') // tell other to refresh 
    },

    async uploadImage (e){
      let VueThis = this;
    
      e.preventDefault();
      const formData = new FormData();

      formData.append('files',this.file);

      axios.post('https://api.enter.hetnieuweinstituut.nl/upload',formData)
        .then((response) =>{
          const room = axios.get(
            `https://api.enter.hetnieuweinstituut.nl/rooms?slug=${this.$route.params.slug}`
          ).then((res)=>{
            const bg_image_index = res.data[0].roomoptions.findIndex((option,index )=> {
              return option.__component == 'room-options.background-image';
            })

            let tempMyObj = Object.assign({}, res.data[0]);
            tempMyObj.roomoptions[bg_image_index].upload = response.data[0];
            
            axios.put(`https://api.enter.hetnieuweinstituut.nl/rooms/${res.data[0].id}/`, {roomoptions : tempMyObj.roomoptions})
              .then((putresponse)=>{
                  this.$emit('uploaded-new-image') // tell local to refresh
                  this.$socket.emit('newImage') // tell other to refresh 
              })
              .catch((puterror)=>{
                console.log(puterror);
              })
            return res.data[0];
          })

        })
        .catch(() =>{
      })
    },

    async resetBackground(){
      const room = axios.get(
            `https://api.enter.hetnieuweinstituut.nl/rooms?slug=${this.$route.params.slug}`
          ).then((res)=>{
            const bg_image_index = res.data[0].roomoptions.findIndex((option,index )=> {
              return option.__component == 'room-options.background-image';
            })

            let tempMyObj = Object.assign({}, res.data[0]);
            tempMyObj.roomoptions[bg_image_index].upload = null
            
            axios.put(`https://api.enter.hetnieuweinstituut.nl/rooms/${res.data[0].id}/`, {roomoptions : tempMyObj.roomoptions})
              .then((putresponse)=>{
                  this.$emit('uploaded-new-image') // tell local to refresh
                  this.$socket.emit('newImage') // tell other to refresh 
              })
              .catch((puterror)=>{
                console.log(puterror);
              })

            return res.data[0];
          })
/*
      const loc = location()
      try{
        await axios.get(`${loc}resetBackground`)
        this.message = 'removed!'
      }
      catch(err){
        console.log(err)
        this.message = "Something went wrong :( " 
      }
      this.$emit('uploaded-new-image') // tell local to refresh
      this.$socket.emit('newImage') // tell other to refresh 
*/
    }

  }, // methods

  mounted(){
    interactions.dragDrop(
      "#upload",
      "#upload-handle",
      this.x,
      this.y,
      this.ratioLock
    );
    interactions.enableFold("#upload-handle", "#upload-content", this.fold);
    }
  }

</script>

<style>
#upload p {
  font-size: var(--button-font-size);
  margin-block-start: 0;
  margin-block-end: 0;
  padding: 5px;
}

#upload-handle {
  position: sticky;
  border-bottom: var(--default-border);
  top: 0;
  margin: 0;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

#upload {
  position:absolute;
  z-index:7;
  margin-top:355px;
  filter: var(--drop-shadow);
}

#upload-content {
  width: 200px;
  overflow-y: auto;
}

/* hide default file upload component */
#upload input[type="file"] {
    display: none;
}

</style>
